import React, { useContext } from 'react';
import { UserContext } from '../../contexts';
import { StatePanel } from '../../components/ui';
import { isRcOrDaoStaff } from '../../core/config/storeId';
import { ShopifySettings } from '../organisms';
import { SettingsTemplate } from '../templates';

// The "Shopify App" settings tab was removed for everyone (F8, Alex
// 2026-10-30). The page is the DAO Shopify feature-quota matrix, so the URL
// still works for RC / DAO staff; anyone else gets the permission panel and
// never calls /api/feature-quotas.
export function ShopifySettingsPage() {
  const { user, activeStoreId } = useContext(UserContext);

  return (
    <SettingsTemplate>
      {isRcOrDaoStaff(user, activeStoreId) ? (
        <ShopifySettings />
      ) : (
        <div className="master-admin-denied">
          <StatePanel state="permission" headingLevel={2} />
        </div>
      )}
    </SettingsTemplate>
  );
}
